import styled from 'styled-components';
export const Anchor = styled.div `
    width: min-content;
`;
